<template lang="pug">
  .container(v-if='editedTag')
    h4 {{$t('Change Tag in Network')}} - {{editedTag.name}}
    el-form(:model='editedTag', @keyup.enter.native='')
      el-form-item
        el-input(id="DeviceTagEditorGlobal-nameInput" :placeholder='$t("name")', v-model='editedTag.name', label='Name')
    el-button-group.float-right
      el-button(
        id="DeviceTagEditorGlobal-saveNetworkTagButton", type='success', size="mini", @click='saveNetworkTag()',
        :disabled='savingNetworkTag'
      )
        font-awesome-icon(icon="save")
        span &nbsp; {{ savingNetworkTag ? $t('saving...') : $t('Change tag text')}}
      el-button(
        id="DeviceTagEditorGlobal-deleteNetworkTagButton", type='success', size="mini", @click='deleteNetworkTag()'
        :disabled='deletingNetworkTag'
      )
        font-awesome-icon(icon="trash")
        span &nbsp; {{ deletingNetworkTag ? $t('deleting...') : $t('Delete tag from network')}}
</template>

<script>

export default {
  props: ['editedTag'],
  components: {
  },
  created () {
  },
  data () {
    return {
      errors: {
      },
      inputVisible: false,
      addTagName: '',
      editTagFormVisible: false,
      savingNetworkTag: false,
      deletingNetworkTag: false
    }
  },
  methods: {
    async saveNetworkTag () {
      this.savingNetworkTag = true
      await this.$store.dispatch('Device/saveDeviceTagInNetwork', this.editedTag)
      this.savingNetworkTag = false
      this.$emit('doneEditTag')
    },
    async deleteNetworkTag () {
      this.deletingNetworkTag = true
      await this.$store.dispatch('Device/deleteDeviceTagFromNetwork', this.editedTag.id)
      this.deletingNetworkTag = false
      this.$emit('doneEditTag')
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
</style>



// WEBPACK FOOTER //
// src/components/Device/DeviceTagEditorGlobal.vue